// extracted by mini-css-extract-plugin
module.exports = {"card":"e6384","wrapper":"_8a930","wide":"_1f328","item":"_5a33d"};